// @core/api/endpoints/calendar/find_available_slots.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  FindAvailableSlotsRequest,
  FindAvailableSlotsResponse,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Find available slots
 * Suggests meeting times when all (or most) requested attendees are available. Considers working hours, existing events, and time zones.
 */
export async function FindAvailableSlots(
  data: FindAvailableSlotsRequest,
  options?: RequestOptions
): Promise<FindAvailableSlotsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/availability/find-slots`;
  const requestOptions = options;
  return client.post<FindAvailableSlotsResponse>(requestPath, data, requestOptions);
}
